import { jsx as _jsx } from "react/jsx-runtime";
var Collapse = function Collapse(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.4157 8.99901L19.0007 9.00001C19.5527 9.00001 20.0007 9.44801 20.0007 10.001C19.9997 10.553 19.5517 11 19.0007 11H18.9997L14.0247 10.997C13.4747 10.997 13.0277 10.552 13.0247 10.002L13.0007 5.00501C12.9977 4.45301 13.4427 4.00301 13.9957 4.00001H14.0007C14.5507 4.00001 14.9977 4.44401 15.0007 4.99501L15.0127 7.57301L18.2927 4.29301C18.6837 3.90201 19.3167 3.90201 19.7077 4.29301C20.0977 4.68401 20.0977 5.31601 19.7077 5.70701L16.4157 8.99901ZM5.00474 13.0004L10.0017 13.0254C10.5517 13.0284 10.9967 13.4744 10.9967 14.0244L11.0007 18.9994C11.0007 19.5514 10.5527 20.0004 10.0007 20.0004C9.44774 20.0004 9.00074 19.5524 9.00074 19.0014L8.99874 16.4164L5.70774 19.7074C5.51174 19.9024 5.25574 20.0004 5.00074 20.0004C4.74474 20.0004 4.48874 19.9024 4.29374 19.7074C3.90274 19.3164 3.90274 18.6834 4.29374 18.2934L7.57274 15.0134L4.99574 15.0004C4.44274 14.9974 3.99774 14.5464 4.00074 13.9954C4.00274 13.4444 4.45074 13.0004 5.00074 13.0004H5.00474Z",
      fill: color
    })
  });
};
export default Collapse;